import React, { type ReactNode } from 'react';
import { Box } from '@planne-software/uni/mui/material';
import {
  CardRoot,
  DependentLabel,
  Description,
  DescriptionSection,
  Divider,
  Header,
  Name,
  PriceQuantityRow,
  Title,
  UnavailableNotice,
} from './styles';

export type TariffCardLayout = 'mobile' | 'desktop';

type TariffCardProps = {
  name: string;
  isAvailable: boolean;
  isDependent: boolean;
  dependentLabel: string;
  unavailableLabel: string;
  description: string;
  priceLine: ReactNode;
  stepper: ReactNode;
  noteSlot?: ReactNode;
  verificationFields?: ReactNode;
  hasError?: boolean;
  layout?: TariffCardLayout;
};

const TariffCard = ({
  name,
  isAvailable,
  isDependent,
  dependentLabel,
  unavailableLabel,
  description,
  priceLine,
  stepper,
  noteSlot,
  verificationFields,
  hasError,
  layout,
}: TariffCardProps) => (
  <CardRoot hasError={!!hasError} dimmed={!isAvailable}>
    <Header layout={layout}>
      <Title>
        <Name>{name}</Name>
        {isDependent ? <DependentLabel>{dependentLabel}</DependentLabel> : null}
      </Title>
      <PriceQuantityRow layout={layout}>
        {isAvailable ? (
          <>
            {priceLine}
            {stepper}
          </>
        ) : (
          <UnavailableNotice>{unavailableLabel}</UnavailableNotice>
        )}
      </PriceQuantityRow>
    </Header>
    {noteSlot ? <Box>{noteSlot}</Box> : null}
    {description ? (
      <DescriptionSection>
        <Divider />
        <Description>{description}</Description>
      </DescriptionSection>
    ) : null}
    {verificationFields ? <Box>{verificationFields}</Box> : null}
  </CardRoot>
);

export default TariffCard;
